import { EmailTable } from "./Table";

export default EmailTable;
